import styled from 'styled-components'

const StyledAcademyCourseList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap: 20px;
  padding: 20px 0;
`

export default StyledAcademyCourseList
